import { render, staticRenderFns } from "./refundForm.vue?vue&type=template&id=5863a1d2&scoped=true&"
import script from "./refundForm.vue?vue&type=script&lang=js&"
export * from "./refundForm.vue?vue&type=script&lang=js&"
import style0 from "./refundForm.vue?vue&type=style&index=0&id=5863a1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863a1d2",
  null
  
)

export default component.exports